import SuburbPestControlPage from "../components/SuburbPestControlPage";
import { IPSWICH_SUBURBS } from "../data/ipswichSuburbs";

export default function PestControlBoovalPage() {
  return <SuburbPestControlPage suburb={IPSWICH_SUBURBS["booval"]} />;
}
